export default __webpack_public_path__ + "static/media/godaddy.2865c579.png";